<script setup lang="ts">
    import TimeActivity from '../../../app/planning/models/TimeActivity';
    import TimeActivityCollection from '../../../app/planning/collections/TimeActivityCollection';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    interface Props extends FormInputProps {
        closeOnSelect?: boolean;
        multiple?: boolean;
        formKey?: string;
        collection: TimeActivityCollection | null;
    }
    const props = withDefaults(defineProps<Props>(), {
        closeOnSelect: true,
        multiple: false,
        formKey: 'timeActivities',
    });
    const inputData: FormInputData = useFormInput(props);

    const select = ref(null);
    const setValue = (value: TimeActivity | Array<TimeActivity>) => {
        inputData.form.set(props.formKey, value);
    };
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectTimeActivity
            ref="select"
            :initial-value="inputData.model.value"
            :collection="props.collection"
            :close-on-select="closeOnSelect"
            :multiple="multiple"
            @selected="setValue"
        ></SelectTimeActivity>
    </FormElement>
</template>
